import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatRealmQueuesFoundEvent} from '../types/events'
import {NinchatState} from 'api/types'
import {extractProperties} from './index'

export const realmQueuesFound: CaseReducer<NinchatState> = (state, action) => {
    const {realm_queues} = extractProperties<NinchatRealmQueuesFoundEvent>(action.payload)
    state._user_realm_queues = realm_queues
}
